import styled from '@emotion/styled';
import { Image } from '@qga/roo-ui/components';

import withProps from '../withProps';
import qantas from './assets/qantas.svg';

const Icon = styled(Image)``;

export default withProps({
  src: qantas,
  alt: 'Qantas',
})(Icon);
